import { Fragment } from 'react';
import classNames from 'classnames';


function Boolean(props) {
	return (
        <Fragment>
			<div className={classNames("searchable-list-filter-button", `searchable-list-filter-button-${props.type}`, { "has-value": props.value })}>
				<div className="searchable-list-filter-button-label">
					{props.label ? props.label : props.name}
				</div>
				{ props.value ? (
					<Fragment>
						<div className="searchable-list-filter-button-value">

						</div>
					</Fragment>
				) : null}
			</div>
		</Fragment>
    );
}

export default Boolean;